import React from 'react';
import { Table } from 'react-bootstrap';
import { BsThreeDots } from 'react-icons/bs';
import { useData } from '../context/DataContext';
import ConnectRequestTable from '../components/ConnectRequestTable';
import useFetchData from '../hooks/useFetchData';
import { config } from '../config/config';
import { getCoachRequests, getNavigatorRequests } from '../config/url';

const ConnectRequests = () => {
  const navigatorData = useFetchData(getNavigatorRequests, config);
  const coachData = useFetchData(getCoachRequests, config);
  return (
    <div className='container p-2 my-4'>
      <h3 className='mb-3'>Connect Requests</h3>

      <div className='mb-3'>
        <h5 className='text-secondary '>Health Navigators</h5>
        {navigatorData != null ? (
          <ConnectRequestTable data={navigatorData} type={'Navigator'} />
        ) : (
          <h4 className='my-4'>Fetching data...</h4>
        )}
      </div>

      <div>
        <h5 className='text-secondary '>Health Coaches</h5>
        {coachData != null ? (
          <ConnectRequestTable data={coachData} type={'Coach'} />
        ) : (
          <h4 className='my-4'>Fetching data...</h4>
        )}
      </div>
    </div>
  );
};

export default ConnectRequests;
